import { InvoiceCycleModel } from '../../api/Argentia/endpoints/invoiceCycle/model/invoiceCycle'
import {
  apiCloseExecutionCycle,
  apiGetInvoiceCycleByID
} from '../../api/Argentia/endpoints/invoiceCyclesExecutions/invoiceCyclesExecutions.api'
import { CloseExecutionCycleRequestModel } from '../../api/Argentia/endpoints/invoiceCyclesExecutions/model/cfExecutionModel'
import {
  AdjustmentConceptSearchResponseModel,
  SettlementsCancelledCheckModel,
  SettlementSearchResponseModel,
  SettlementsInvoicesKPIsResponseModel,
  SettlementsKPIsResponseModel,
  SettlementsObjectionsTableModel,
  SettlementTableModel
} from '../../api/Argentia/endpoints/settlements/model/settlements'
import {
  apiFetchObjectionsBySettlementID,
  apiGetHasCancelledOrPendingSettlements,
  apiGetSettlementsInvoicesLandingKpis,
  apiGetSettlementsLandingKpis,
  apiGetSettlementsObjections,
  apiPostAdjustmentConceptsSearch,
  apiPostClosedSettlementsSearch,
  apiPostGenerateLiquidations,
  apiPostSettlementsSearch
} from '../../api/Argentia/endpoints/settlements/settlements.api'
import { apiUploadInvoiceCodesFile } from '../../api/Pioneer/endpoints/files/files.api'
import {
  InvoiceCodesFileUploadRequestModel,
  InvoiceCodesFileUploadResponseModel
} from '../../api/Pioneer/endpoints/files/models/files'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import { mapSettlementTableApiResponse } from './settlements.mapper'
import {
  AdjustmentConceptSearchRequestModel,
  ClosedSettlementsSearchRequest,
  RegenerateFormData,
  SettlementSearchRequestModel
} from './settlements.models'

export const getSettlementLandingKpis = async (
  executionCycleId: number
): Promise<ServiceResponse<SettlementsKPIsResponseModel | undefined>> => {
  return await apiGetSettlementsLandingKpis(executionCycleId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getSettlementsInvoicesLandingKpis = async (
  executionCycleId: number
): Promise<ServiceResponse<SettlementsInvoicesKPIsResponseModel | undefined>> => {
  return await apiGetSettlementsInvoicesLandingKpis(executionCycleId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getSettlementObjections = async (
  executionCycleId: number
): Promise<ServiceResponse<SettlementsObjectionsTableModel[] | undefined>> => {
  return await apiGetSettlementsObjections(executionCycleId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchObjectionsBySettlementID = async (
  invoiceID: number
): Promise<ServiceResponse<any>> => {
  return await apiFetchObjectionsBySettlementID(invoiceID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getSettlementsTableData = async (
  request: SettlementSearchRequestModel
): Promise<ServiceResponse<SettlementSearchResponseModel | undefined>> => {
  return await apiPostSettlementsSearch(request)
    .then(response => {
      if (response && response.settlements) {
        return createSuccessServiceResponse({
          ...response,
          settlements: mapSettlementTableApiResponse(response.settlements)
        })
      }
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getInvoiceCycleByID = async (
  id: number
): Promise<ServiceResponse<InvoiceCycleModel | undefined>> => {
  return await apiGetInvoiceCycleByID(id)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const generateLiquidationsAsync = async (
  executionCycleId: number,
  params?: RegenerateFormData
): Promise<ServiceResponse<any>> => {
  return await apiPostGenerateLiquidations(executionCycleId, params)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getClosedSettlementsByEmissionDate = async (
  request: ClosedSettlementsSearchRequest
): Promise<ServiceResponse<SettlementTableModel[] | undefined>> => {
  return await apiPostClosedSettlementsSearch(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const closeExecutionCycleAsync = async (
  request: CloseExecutionCycleRequestModel
): Promise<ServiceResponse<void | undefined>> => {
  return await apiCloseExecutionCycle(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getHasCancelledOrPendingSettlements = async (
  executionCycleId: number
): Promise<ServiceResponse<SettlementsCancelledCheckModel | undefined>> => {
  return await apiGetHasCancelledOrPendingSettlements(executionCycleId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const searchAdjustmentConcepts = async (
  request: AdjustmentConceptSearchRequestModel
): Promise<ServiceResponse<AdjustmentConceptSearchResponseModel | undefined>> => {
  return await apiPostAdjustmentConceptsSearch(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const uploadInvoiceCodesFile = async (
  request: InvoiceCodesFileUploadRequestModel
): Promise<ServiceResponse<InvoiceCodesFileUploadResponseModel | undefined>> => {
  return await apiUploadInvoiceCodesFile(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
